<template>
  <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 pregunta-opcio-enunciat">
            <h6 class="m-0 font-weight-bold text-primary">{{this.numPregunta}}. {{pregunta.enunciat | etiqueta}}</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body pregunta-opcio-resposta">
              <b-form-group>
                <b-form-radio v-for="(item) in pregunta.atributsResposta.opcions" :key="item.valor" v-model="valor" :name="`opcio-${pregunta.idPregunta}`" :value="item.valor">{{item.descripcio | etiqueta}}</b-form-radio>
              </b-form-group>           
          </div>
 </div>
 
</template>

<script>
export default {
  name: "pregunta-opcio",
  props: {
    pregunta:{
      type: Object,
      required: true
    },
    valorInicial:{
      type: String,
      required: true
    },
    numPregunta:{
      type: String,
      required: true
    },
    idPregunta:{
      type: Number,
      required: true
    }    
  },   
  data() {
    return {
      valor : ''
    };
  },
  methods: {
    validate(){
        return this.valor!='';
    },getValor(){
      console.log(this.valor);
        return this.valor;
    },getIdPregunta(){
      return this.idPregunta;
    }  
  },
  mounted() {    
    this.valor = this.valorInicial;
  }
};
</script>

<style>
.pregunta-opcio-enunciat{
  text-align: left;
}
.pregunta-opcio-resposta{
  text-align: left;
}
.pregunta-opcio-resposta .custom-radio{
  margin: .3rem!important;
}
</style>